import {useQuery} from "@sveltestack/svelte-query"
import {derived} from "svelte/store"

export function useMyProjectPermission(projectId) {
  const queryResult = useQuery(
    `/api/me/projects/${projectId}/permission`
  )

  const myProjectPermission = derived(
    queryResult,
      values => {
        return values.data?.type
      }
  )
  const authorize = derived(myProjectPermission, myProjectPermission => {
    return (required) => {
      switch (myProjectPermission) {
        case "ServerAdmin":
          return true
        case "ProjectAdmin":
          return required !== "ServerAdmin"
        case "ResultInput":
          return required !== "ServerAdmin" && required !== "ProjectAdmin"
        case "ReadOnly":
          return !required || required === "ReadOnly"
        default:
          return false
      }
    }
  })
  return {
    permission: myProjectPermission,
    authorize,
  }
}
